(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'anonToolbar',
            [
                'CHROME',
                AnonToolbarFactory
            ]
        );

    // Factory Method
    function AnonToolbarFactory(CHROME)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            controller: 'ToolbarController',
            controllerAs: 'toolbarCtrl',
            templateUrl: CHROME.PREFIX + CHROME.TOOLBAR.ANON + CHROME.POSTFIX
        };

    }
})();



